<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate>Settings.SSO</h3>
    </div>
</div>

<!-- <div class="d-flex row-cols-12">
    <div class="px-4 my-2 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label class="form-label" translate="Settings.SecuritySection.SSO.SSO"></label>
        <div ngbDropdown class="dropdown" ngDefaultControl id="defaultSender">
            <button class="btn btn-sm language dropdown-toggle form-control text-truncate default" type="button" id="dropdownMenu" ngbDropdownToggle>
                {{ ssoprovider?.ssoProvider.displayName | translate}}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <ng-container *ngFor="let schema of ssoprovider?.authenticationSchemas">
                    <button ngbDropdownItem (click)="updateSsoProvider(schema.name)" translate>{{schema.displayName}}</button> 
                </ng-container>
            </div>
        </div>
    </div>
</div> -->
<div class="px-4 my-2 mb-1 d-table col-12">

    <span class="pt-5 pb-2 col-12" translate="Settings.SecuritySection.SSO.SSO"></span>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <ul class="mt-2 w-100 list-group">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-6"><span translate="Settings.SecuritySection.SSO.Options"></span></div>
                </div>
            </li>
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Force_AAD">
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-12 text-truncate float-none form-check form-switch">
                        <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="smsOtp" 
                        (click)="updateSsoRequired('SsoRequired',$event)" 
                        [checked]="ssoprovider?.ssoProvider.name === 'AzureAD' && ssoRequired"
                        [disabledByPermission]="permissionEnum.Perm_Force_AAD">
                        <label class="col-10" for="smsOtp" translate="Settings.SecuritySection.SSO.ForceMicrosoftAzureAD"><app-info-button labelName="Settings.SecuritySection.SSO.ForceMicrosoftAzureADTooltip"></app-info-button></label>
                    </div>
                </div>
            </li>
            </app-hide-by-permission-wrapper>
        </ul>
    </div>
</div>

<!-- <div class="mx-0 p-1 col-12 row text-wrap border border-top-0 border-bottom-0 lh-base">
    <div class="col-9 d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="SSoRequired" name="SSoRequired" [(ngModel)]="ssoRequired" (click)="updateSsoRequired('SsoRequired',$event)">
        <label class="form-check-label pt-1 col-10" for="SSoRequired" translate="Settings.OrganisationBrandingSection.ForceSSO">
            <app-info-button labelName="Settings.OrganisationBrandingSection.ForceSSOTooltip"></app-info-button>
        </label>
    </div>
</div> -->
